import BaseDialog from '../BaseDialog';

const EventUpdatedDialog = ({ isVisible, onClose }) => {

  return (
    <BaseDialog isVisible={isVisible} onClose={onClose}>
      <div>
        更新が完了しました。
      </div>
    </BaseDialog>
  );
};

export default EventUpdatedDialog;
